import Header from "../../../../Components/Header";
import PurchaseForm from "./PurchaseForm";
import { Helmet } from "react-helmet";

const CreatePutAway = () => {
  return (
		<div className="d-flex flex-column" style={{ height: "100vh" }}>
			<Helmet>
				<title>Putaway - Create</title>
			</Helmet>
			<Header />
			<div
				className="container-fluid maindiv d-flex flex-column"
				style={{ flexGrow: "1" }}
			>
				<PurchaseForm />
			</div>
		</div>
	);
};

export default CreatePutAway;
